
jQuery(document).on("click", ".show-size-pop", function($){
  jQuery(".size-chart-pop_qv").addClass("showpop_sizeactv");
});
jQuery(document).on('click', ".close-size-popup", function(){
  jQuery(".size-chart-pop_qv").removeClass("showpop_sizeactv");
})
jQuery(document).ready(function($){
  jQuery('body').on("click", ".size-circle:not(.disabled)", function(event){
    event.preventDefault();

    // var varationId = jQuery(event.target).attr('data-var-handle');
    // var varationValue = jQuery(event.target).attr('data-var-value');
    // var varationPositionInput = jQuery(event.target).attr('data-var-pos');
    var varationId = jQuery(this).find('button').attr('data-var-handle');
    var varationValue = jQuery(this).find('button').attr('data-var-value');
    var varationPositionInput = jQuery(this).find('button').attr('data-var-pos');
    
    var currentUrl = window.location.href;

    var parentHolder = $(this).parent().parent();
    var theSizeElem = parentHolder.find('.quick-view-button').find('.hiddenContent');
    // var theSizeElem = jQuery(event.target).closest(".grid-quickview").find(jQuery(event.target).attr('data-product-id'));

    jQuery.magnificPopup.open({
        items: {
            src: theSizeElem,
        },
        type: 'inline',
        closeOnBgClick: true,
        callbacks: {
          open() {
                  const $slider = jQuery('.qv-product-images');
                  if (!jQuery('.qv-product-images').hasClass('slick-initialized')) {
                    $slider.slick({
                       dots: false,
                        arrows: true,
                        respondTo: "min",
                        useTransform: false,
                        prevArrow:"<button type='button' class='custom_slick custom_prev slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='15.556' height='28.287' viewBox='0 0 15.556 28.287'><path id='arrow_sp' data-name='arrow sp' d='M0,14.145,14.143,0l1.413,1.414L2.826,14.145,15.556,26.873l-1.413,1.414Z'/></svg></button>",
                        nextArrow:"<button type='button' class='custom_slick custom_next slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='15.556' height='28.287' viewBox='0 0 15.556 28.287'><path id='arrow_sn' data-name='arrow sn' d='M0,14.143,14.143,28.287l1.413-1.414L2.826,14.143,15.556,1.414,14.143,0Z' transform='translate(15.556 28.287) rotate(180)'/></svg></button>"
                    });
                  }else{
                    jQuery('.qv-product-images').slick('refresh');
                  }
                  $('.slick-media').slick('unslick').slick('reinit');

                  $('.product-form__input.opt-Size input[type="radio"]').prop('checked',false);
                  $("#"+varationPositionInput).prop('checked',true);

                  $('product-form form input[name="id"]').val(varationId);

          },
          close(){
              window.history.replaceState({ }, '', currentUrl);
              $('.slick-media').slick('unslick').slick('reinit');
          }
        },
    });

  })
  jQuery('body').on("click", ".coll_qv_btn", function(event) {
    event.preventDefault();
      // do something
      var varationId = $(this).find('button').attr('data-var-handle');
      var varationValue = $(this).find('button').attr('data-var-value');
      var  varationPositionInput = $(this).find('button').attr('data-var-pos');

      var idtomatch = $(this).attr('data-matchid');
      var matchelement = $('.sizelist .size-circle button[data-var-handle="'+idtomatch+'"]').attr('data-var-pos');
    
      var currentUrl = window.location.href;

      var theEleme = jQuery(event.target).closest(".coll_qv_button_wrapper").find(jQuery(event.target).attr('data-product-id'))

          // jQuery(event.target).magnificPopup({
          $.magnificPopup.open({
            type:'inline',
             items: {
                src: theEleme,
            },
            type: 'inline',
            closeOnBgClick: true,

              callbacks: {
                open() {
                  const $slider = jQuery('.qv-product-images');

                  if (!jQuery('.qv-product-images').hasClass('slick-initialized')) {
                    jQuery('.qv-product-images').slick({
                       dots: false,
                        arrows: true,
                        respondTo: "min",
                        useTransform: false,
                        prevArrow:"<button type='button' class='custom_slick custom_prev slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='15.556' height='28.287' viewBox='0 0 15.556 28.287'><path id='arrow_sp' data-name='arrow sp' d='M0,14.145,14.143,0l1.413,1.414L2.826,14.145,15.556,26.873l-1.413,1.414Z'/></svg></button>",
                        nextArrow:"<button type='button' class='custom_slick custom_next slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='15.556' height='28.287' viewBox='0 0 15.556 28.287'><path id='arrow_sn' data-name='arrow sn' d='M0,14.143,14.143,28.287l1.413-1.414L2.826,14.143,15.556,1.414,14.143,0Z' transform='translate(15.556 28.287) rotate(180)'/></svg></button>"
                    });
                  }else{
                    jQuery('.qv-product-images').slick('refresh');

                  }
                  $('.slick-media').slick('unslick').slick('reinit');
                  jQuery('.qv-product-images').slick('slickGoTo', +$(this).attr('index'));

                  $('.product-form__input.opt-Size input[type="radio"]').prop('checked',false);
                  $("#"+matchelement).prop('checked',true);
                  $('product-form form input[name="id"]').val(idtomatch);
                },
                close(){
                  window.history.replaceState({ }, '', currentUrl);
                  $('.slick-media').slick('unslick').slick('reinit');
                }
            },
          });
          // $('.close_btn').magnificPopup('close');

          $cart_item = document.getElementsByTagName('cart-items');

          $('.product-form__submit').on('click', function(){
            setTimeout(function(){
              $.magnificPopup.close();
            }, 300)
          })
              // $('.close_btn').magnificPopup('close');
  });
})
document.addEventListener('click',function(){
  const tabs = document.querySelectorAll('[role="tab"]');
  const tabList = document.querySelector('[role="tablist"]');

  tabs.forEach(tab => {
      tab.addEventListener('click', changeTabs);
  });
   // Enable arrow navigation between tabs in the tab list
  let tabFocus = 0;
  if(tabList){
    tabList.addEventListener('keydown', e => {
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute('tabindex', -1);
        if (e.keyCode === 39) {
          tabFocus++;
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
        } else if (e.keyCode === 37) {
          tabFocus--;
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute('tabindex', 0);
        tabs[tabFocus].focus();
      }
    });
  }
});

function changeTabs(e) {
  const target = e.target;
  const parent = target.parentNode;
  const grandparent = parent.parentNode;

  // Remove all current selected tabs
  parent
    .querySelectorAll('[aria-selected="true"]')
    .forEach(t => t.setAttribute('aria-selected', false));

  // Set this tab as selected
  target.setAttribute('aria-selected', true);

  // Hide all tab panels
  grandparent
    .querySelectorAll('[role="tabpanel"]')
    .forEach(p => p.setAttribute('hidden', true));

  // Show the selected panel
  grandparent.parentNode
    .querySelector(`#${target.getAttribute('aria-controls')}`)
    .removeAttribute('hidden');
}
 jQuery('body').on("click", ".size_picks_popup:not(.disabled)", function(event){
      event.stopPropagation();
      var thissku = jQuery(this).attr('data-variantsku');
      jQuery('.on_popup_element .sku_variant').html('Style: '+ thissku);
  });
